import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Button from '../../../components/common/Button';
import { attemptToCashIn as dispatchAttemptToCashIn } from '../../../modules/cimb/actions';
import { open } from '../../../modules/modal/actions';
import { showList as dispatchShowList } from '../../openBets/actions';
import { countOpenBets, getCashInStatus, getFormattedCurrentBet } from '../../openBets/selectors';

const CashInWidget = ({
  betId,
  slipId,
  betPotentialPayout,
  betStake,
  betCashInPrice,
  freeBet,
  cashInAvailable,
  cashInSuspended,
  cashInValue,
  cashOutPending,
  cashInValueCapped,
  attemptToCashIn,
  showCashInInfo,
  enableCashIn
}) => {
  const cashInSuspendedIcon = (
    <i className="icon icon--info cash-in-widget__suspended-info-icon" />
  );

  const cashInButtonConfig = {
    className: '',
    text: '',
    disabled: false,
    onClick: () => attemptToCashIn(cashInValue, betId, slipId)
  };

  if (cashInSuspended) {
    cashInButtonConfig.text = (
      <div>
        Cash out suspended {cashInSuspendedIcon}
      </div>
    );
    cashInButtonConfig.className = 'button--secondary';
    cashInButtonConfig.onClick = showCashInInfo;
  } else if (cashOutPending) {
    cashInButtonConfig.text = 'Cash out pending';
    cashInButtonConfig.disabled = true;
  } else if (!cashInAvailable || !enableCashIn) {
    cashInButtonConfig.text = (
      <div>
        Cash out not available {cashInSuspendedIcon}
      </div>
    );
    cashInButtonConfig.className = 'button--secondary';
    cashInButtonConfig.onClick = showCashInInfo;
  } else {
    cashInButtonConfig.text = `CASH OUT: ${betCashInPrice}`;
  }

  return (
    <div className="cash-in-widget">
      <div className="container--fixed">
        <div className="cash-in-widget__content">
          {freeBet && (
            <div className="cash-in-widget__note">
              Note: Free bet stake has <b>already</b> been deducted
            </div>
          )}
          {cashInValueCapped && (
            <div className="cash-in-widget__note">
              Note: Cash out value is capped at £50,000
            </div>
          )}
          <Button
            onClick={cashInButtonConfig.onClick}
            disabled={cashInButtonConfig.disabled}
            className={`cash-in-widget__button ${cashInButtonConfig.className}`}
          >
            {cashInButtonConfig.text}
          </Button>
          <div className="cash-in-widget-summary">
            <div className="cash-in-widget-summary__cell">
              <span className="cash-in-widget-summary__label">Stake</span>
              {betStake}
            </div>
            <div className="cash-in-widget-summary__cell">
              <span className="cash-in-widget-summary__label">Returns</span>
              {betPotentialPayout}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

CashInWidget.propTypes = {
  betId: PropTypes.string.isRequired,
  slipId: PropTypes.string.isRequired,
  betPotentialPayout: PropTypes.string.isRequired,
  betStake: PropTypes.string.isRequired,
  betCashInPrice: PropTypes.string,
  freeBet: PropTypes.bool.isRequired,
  cashInAvailable: PropTypes.bool,
  cashInSuspended: PropTypes.bool,
  cashInValue: PropTypes.string,
  cashOutPending: PropTypes.bool.isRequired,
  cashInValueCapped: PropTypes.bool.isRequired,
  attemptToCashIn: PropTypes.func.isRequired,
  showCashInInfo: PropTypes.func.isRequired,
  enableCashIn: PropTypes.bool
};

const mapStateToProps = state => {
  const {
    betId,
    slipId,
    betPotentialPayout,
    betStake,
    betCashInPrice,
    freeBet
  } = getFormattedCurrentBet(state);

  const {
    cashInAvailable,
    cashInSuspended,
    cashInValue,
    cashOutPending,
    cashInValueCapped
  } = getCashInStatus(state);

  const betsCount = countOpenBets(state);

  return {
    betId,
    slipId,
    betPotentialPayout,
    betStake,
    betCashInPrice,
    freeBet,
    cashInAvailable,
    cashInSuspended,
    cashInValue,
    cashOutPending,
    cashInValueCapped,
    betsCount
  };
};

const mapDispatchToProps = {
  showList: dispatchShowList,
  attemptToCashIn: dispatchAttemptToCashIn,
  showCashInInfo: open.bind(null, { componentName: 'CashInInfo' })
};

export default connect(mapStateToProps, mapDispatchToProps)(CashInWidget);
